var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgQualification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34.035 34.035",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.855 5.627c-3.5 0-6.347 2.847-6.347 6.347s2.847 6.347 6.347 6.347c3.5 0 6.348-2.847 6.348-6.347s-2.848-6.347-6.348-6.347m0 14.458c-4.473 0-8.111-3.638-8.111-8.111s3.638-8.111 8.111-8.111c4.473 0 8.111 3.638 8.111 8.111s-3.638 8.111-8.111 8.111m-3.607.633a.231.231 0 0 0-.264.08l-4.2 6.03c-.056.08-.135.073-.176-.015l-2.247-4.82a.338.338 0 0 1 .027-.304l2.408-3.458a.307.307 0 0 0 .015-.299l-.786-1.403c-.047-.085-.132-.089-.187-.009L4.36 21.514a.34.34 0 0 0-.027.304l3.971 8.518c.041.088.12.095.175.015l6.182-8.876c.055-.08.027-.174-.063-.21zm7.215 0a.231.231 0 0 1 .264.08l4.2 6.03c.056.08.135.073.176-.015l2.247-4.82a.338.338 0 0 0-.027-.304l-2.408-3.458a.308.308 0 0 1-.015-.299l.786-1.403c.048-.085.132-.089.187-.009l3.478 4.994a.34.34 0 0 1 .027.304l-3.971 8.518c-.041.088-.12.095-.175.015l-6.182-8.876c-.055-.08-.027-.174.063-.21z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualification);
export default __webpack_public_path__ + "static/media/Qualification.afc510b5b61aa689a1be0d191d6f582c.svg";
export { ForwardRef as ReactComponent };